const s = ["default", "primary", "success", "warning", "error"], o = ["sm", "md", "lg"], t = ["filled", "outlined"], n = "default", c = "md", e = "filled";
export {
  n as DEFAULT_COLOR,
  c as DEFAULT_SIZE,
  e as DEFAULT_VARIANT,
  s as colors,
  o as sizes,
  t as variants
};
